export const ASSETS = {
  blueprint:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2f4aa183-c8aa-4ea6-aa60-1dd4d6d28ffc/artifacts/05b5k513_Documentazione.png",
  doc3d: "https://customer-assets-eiarnc6j.emergentagent.net/job_2f4aa183-c8aa-4ea6-aa60-1dd4d6d28ffc/artifacts/qkdrkre4_documetnazione3d.webp",
  risk: "https://customer-assets-eiarnc6j.emergentagent.net/job_2f4aa183-c8aa-4ea6-aa60-1dd4d6d28ffc/artifacts/gjmje3cg_RiskAnalyss.png",
  sicurezza:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2f4aa183-c8aa-4ea6-aa60-1dd4d6d28ffc/artifacts/ihxv39va_SicurezzaMacchine.webp",
  pm: "https://customer-assets-eiarnc6j.emergentagent.net/job_2f4aa183-c8aa-4ea6-aa60-1dd4d6d28ffc/artifacts/8ftocez8_upload267project-management-300x150.jpg",
  blueprintSketch:
    "https://images.pexels.com/photos/19895919/pexels-photo-19895919.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cadEngineer:
    "https://images.pexels.com/photos/3862372/pexels-photo-3862372.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  robotics:
    "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85",
  factory:
    "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85",
  cyber:
    "https://images.unsplash.com/photo-1698668975271-2ba9a323be6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwc2VydmVyJTIwUExDJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTEzNTkzMTJ8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_ORDER = [
  "manualistica",
  "documentazione-3d",
  "risk-analysis",
  "regolamento-ue",
  "certificazioni-e-sicurezza",
  "project-management",
  "industria-4-5",
  "ai",
];

export const dict = {
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      risk: "Risk Analysis",
      regulation: "Regolamento UE",
      industry: "Industria 4.0/5.0",
      ai: "AI",
      contacts: "Contatti",
      cta: "Richiedi Consulenza",
      menu: "Menu",
      close: "Chiudi",
    },
    common: {
      discover: "Scopri di più",
      allServices: "Tutti i servizi",
      backToServices: "Torna ai servizi",
      external: "Sito esterno",
      emailUs: "Scrivici",
    },
    home: {
      heroOverline: "Aldebran — Engineering Group · Dal 1999",
      heroLines: ["Ingegneria, conformità", "e documentazione tecnica", "senza confini."],
      heroSub:
        "Da oltre 25 anni affianchiamo i costruttori di macchine e impianti: manualistica, analisi dei rischi, certificazioni e trasformazione digitale, in ogni mercato del mondo.",
      heroCtaPrimary: "Scopri i servizi",
      heroCtaSecondary: "Regolamento UE 2023/1230",
      stats: [
        { value: "25+", label: "anni di esperienza" },
        { value: "8", label: "aree di specializzazione" },
        { value: "ISO 13849", label: "IEC 62061 · standard applicati" },
        { value: "2027", label: "nuovo Regolamento Macchine" },
      ],
      aboutOverline: "Chi siamo",
      aboutTitle: "Un partner tecnico unico, dalla progettazione al mercato.",
      aboutText:
        "Aldebran fornisce da oltre 25 anni servizi e prodotti tecnici alle aziende. Uniamo competenza normativa, cultura ingegneristica e strumenti digitali per portare macchine e impianti sui mercati internazionali, in sicurezza e in conformità.",
      aboutCta: "Parla con un esperto",
      servicesOverline: "Cosa facciamo",
      servicesTitle: "Otto aree di specializzazione. Un unico interlocutore.",
      servicesSub:
        "Dalla documentazione tecnica all'intelligenza artificiale: copriamo l'intero ciclo di vita del prodotto industriale.",
      certifico: {
        badge: "Nuovo · Prodotto Aldebran",
        title: "CertificoQR",
        text: "La certificazione diventa immediata: ogni macchina, un QR code. Fascicolo tecnico, manuali e dichiarazioni di conformità sempre accessibili, aggiornati e verificabili da chiunque, ovunque.",
        cta: "Visita certificoqr.com",
      },
      regOverline: "Scadenza normativa",
      regTitle: "Regolamento Macchine (UE) 2023/1230",
      regText:
        "Sostituisce la Direttiva 2006/42/CE e introduce requisiti significativi per i costruttori. L'applicazione obbligatoria decorre dal 20 gennaio 2027: prepararsi per tempo significa proteggere l'accesso al mercato UE.",
      regDays: "giorni all'applicazione obbligatoria",
      regCta: "Come ti prepariamo",
      marquee: [
        "Documentazione Tecnica",
        "Risk Analysis",
        "Marcatura CE",
        "Regolamento UE 2023/1230",
        "Documentazione 3D",
        "Project Management",
        "Industria 4.0/5.0",
        "Intelligenza Artificiale",
        "CertificoQR",
      ],
      ctaTitle: "Parliamo del vostro prossimo progetto.",
      ctaText:
        "Raccontateci la vostra macchina, il vostro impianto, il vostro mercato di destinazione. Vi risponderemo con una proposta concreta.",
      ctaButton: "Richiedi una consulenza",
    },
    services: [
      {
        slug: "manualistica",
        title: "Documentazione Tecnica",
        short:
          "Manuali d'uso e manutenzione chiari, conformi e multilingua: parte integrante del vostro prodotto.",
        image: ASSETS.blueprintSketch,
        path: "/servizi/manualistica",
      },
      {
        slug: "documentazione-3d",
        title: "Documentazione 3D",
        short:
          "Contenuti tecnici interattivi dai vostri modelli CAD: viste esplose, procedure step-by-step, PDF 3D navigabili.",
        image: ASSETS.doc3d,
        path: "/servizi/documentazione-3d",
      },
      {
        slug: "risk-analysis",
        title: "Risk Analysis",
        short:
          "Analisi dei rischi di macchine e impianti secondo EN ISO 13849-1/2, IEC 62061, FTA, PHA, Monte Carlo.",
        image: ASSETS.risk,
        path: "/risk-analysis",
      },
      {
        slug: "regolamento-ue",
        title: "Regolamento UE 2023/1230",
        short:
          "Supporto completo nel passaggio dalla Direttiva 2006/42/CE al nuovo Regolamento Macchine.",
        image: ASSETS.blueprint,
        path: "/regolamento-ue",
      },
      {
        slug: "certificazioni-e-sicurezza",
        title: "Certificazioni e Sicurezza",
        short:
          "Certificazione di macchine e impianti secondo le direttive Macchine, ATEX, PED, EMC e marcatura CE.",
        image: ASSETS.sicurezza,
        path: "/servizi/certificazioni-e-sicurezza",
      },
      {
        slug: "project-management",
        title: "Project Management",
        short:
          "Pianificazione, monitoraggio e controllo: WBS, Gantt, gestione dei rischi e della documentazione di progetto.",
        image: ASSETS.pm,
        path: "/servizi/project-management",
      },
      {
        slug: "industria-4-5",
        title: "Industria 4.0/5.0",
        short:
          "Sensoristica, IoT e Digital Twin per trasformare la fabbrica in un ecosistema connesso e intelligente.",
        image: ASSETS.factory,
        path: "/industria-4-5",
      },
      {
        slug: "ai",
        title: "AI per l'Industria",
        short:
          "Manutenzione predittiva, visione artificiale e assistenti virtuali: l'AI applicata concretamente all'industria.",
        image: ASSETS.robotics,
        path: "/ai",
      },
    ],
    servicesPage: {
      overline: "I nostri servizi",
      title: "Competenza ingegneristica, dalla carta al digitale.",
      sub: "Otto aree di specializzazione che coprono l'intero ciclo di vita del prodotto industriale: documentazione, conformità, sicurezza, innovazione.",
      certifico: {
        badge: "Prodotto Aldebran",
        title: "CertificoQR — la certificazione a portata di scansione",
        text: "CertificoQR è la piattaforma Aldebran che collega ogni macchina a un QR code univoco: fascicolo tecnico, manuali d'uso, dichiarazioni di conformità e documenti di manutenzione diventano accessibili in pochi secondi, da qualsiasi dispositivo, in ogni lingua. Niente più documenti smarriti, versioni obsolete o audit rallentati.",
        points: [
          "Fascicolo tecnico digitale sempre aggiornato",
          "Accesso immediato tramite QR code sulla macchina",
          "Documenti multilingua e controllati in revisione",
          "Tracciabilità completa per audit e ispezioni",
        ],
        cta: "Vai a certificoqr.com",
      },
    },
    details: {
      "manualistica": {
        overline: "Servizi · Documentazione Tecnica",
        title: "Manualistica",
        lead: "Il manuale d'uso è parte integrante del prodotto: senza di esso nessuna macchina può essere venduta nel mercato europeo. E va pubblicato nella lingua del Paese in cui il prodotto viene commercializzato.",
        sections: [
          {
            heading: "Il costo di un manuale carente",
            list: [
              "Danni a persone o cose a seguito di un utilizzo improprio del prodotto",
              "Costosi casi di responsabilità di prodotto",
              "Richiami di prodotto sul mercato",
              "Deterioramento della qualità percepita",
              "Danno all'immagine del marchio",
              "Utenti esasperati, che scelgono la concorrenza",
            ],
          },
          {
            heading: "Il valore di un manuale efficace",
            list: [
              "Minimizza i danni a persone e cose",
              "Riduce il rischio di responsabilità di prodotto",
              "Abbassa le spese per i servizi post-vendita",
              "Migliora la qualità generale del prodotto",
              "Rafforza il marchio",
              "Genera clienti soddisfatti",
            ],
          },
          {
            heading: "Perché scegliere Aldebran",
            paragraph:
              "I nostri manuali d'uso proteggono l'utente con istruzioni di sicurezza chiare, sono giuridicamente validi e conformi agli standard, facilmente comprensibili e privi di tecnicismi, progettati per una lettura rapida e corredati da illustrazioni chiare e significative.",
          },
          {
            heading: "Servizi di traduzione",
            paragraph:
              "I vostri testi vengono tradotti da traduttori madrelingua altamente qualificati. Un moderno sistema di gestione delle traduzioni riduce tempi e costi durante la traduzione e l'impaginazione.",
          },
        ],
      },
      "documentazione-3d": {
        overline: "Servizi · Documentazione 3D",
        title: "Documentazione 3D",
        lead: "La documentazione 3D è la nuova frontiera della documentazione tecnica. Aldebran propone soluzioni ad altissimo rendimento che rivoluzionano la rappresentazione e la pubblicazione delle informazioni in tutti i settori.",
        sections: [
          {
            heading: "Contenuti tecnici personalizzati",
            list: [
              "Istruzioni di lavoro dettagliate",
              "Cataloghi di parti illustrate",
              "Manuali tecnici interattivi",
              "Documenti PDF 3D personalizzati e navigabili",
            ],
          },
          {
            heading: "Creazione di contenuti visivi",
            paragraph:
              "Produciamo contenuti chiari e intuitivi a partire dai modelli CAD: viste esplose, procedure step-by-step, distinte base (BOM/part-list), illustrazioni tecniche e testi descrittivi multilingua.",
            image: ASSETS.doc3d,
          },
          {
            heading: "Distribuzione e collaborazione cloud",
            list: [
              "Distribuzione sicura e privata dei contenuti 3D",
              "Collaborazione in tempo reale con team internazionali",
              "Gestione di aggiornamenti e revisioni della documentazione",
            ],
          },
          {
            heading: "Soluzioni interattive e multimediali",
            list: [
              "Istruzioni visive per montaggio e manutenzione",
              "Cataloghi interattivi per e-commerce e manutenzione remota",
              "Integrazione con piattaforme web e sistemi PLM/ERP",
            ],
          },
        ],
      },
      "certificazioni-e-sicurezza": {
        overline: "Servizi · Certificazioni",
        title: "Certificazioni e Sicurezza Macchine",
        lead: "Assistenza completa nella certificazione di macchine, impianti e prodotti, e nella sicurezza dei luoghi di lavoro, con un respiro internazionale.",
        sections: [
          {
            heading: "Cosa facciamo",
            list: [
              "Certificazione in accordo alle direttive Macchine, Dispositivi Medici, Bassa Tensione, Compatibilità Elettromagnetica, PED e prodotti da costruzione",
              "Consulenza sulla sicurezza dei luoghi di lavoro, analisi dei rischi, prove di rumore, misure ambientali, perizie asseverate",
              "Assistenza nell'applicazione di leggi locali e standard in progetti di impianti internazionali",
              "Contatti con istituzioni ed enti normativi esteri per costruzioni, sicurezza, protezione ambientale, certificazione e responsabilità di prodotto",
              "Vendita e ricerca di documenti tecnici e norme: standard tecnici, norme militari, codici, leggi e regolamenti internazionali",
              "Supervisione di progetto per la corrispondenza alle norme ISO, DIN, VDI, AENOR, AFNOR, UNI, BS, GOST, SNIP",
            ],
          },
        ],
      },
      "project-management": {
        overline: "Servizi · Project Management",
        title: "Project Management",
        lead: "Pianifichiamo, monitoriamo e consegniamo i vostri progetti nel rispetto delle procedure aziendali e degli obiettivi concordati.",
        sections: [
          {
            heading: "Le attività del servizio",
            list: [
              "Impostazione e pianificazione dei nuovi progetti nel rispetto delle procedure definite in azienda o dal cliente",
              "Analisi degli obiettivi e delle specifiche, stima dei costi e dei tempi",
              "Monitoraggio e gestione degli avanzamenti per i progetti in essere",
              "Planner per il caricamento dei dati di progetto, l'analisi e la produzione di reportistica",
              "Creazione e gestione della WBS, del network e del Gantt di progetto",
              "Definizione delle procedure",
              "Gestione delle criticità e dei rischi di progetto",
              "Gestione della documentazione di progetto",
              "Assistenza e facilitazione delle riunioni di progetto con le varie parti coinvolte",
              "Consegna della documentazione al committente",
            ],
          },
        ],
      },
    },
    pages: {
      risk: {
        overline: "Servizi · Sicurezza",
        title: "Risk Analysis",
        lead: "Analisi dei rischi di macchine e impianti in conformità alle direttive applicabili — Macchine, PED, ATEX — con le metodologie EN ISO 13849-1/2, IEC 62061, McKinney, FTA, PHA e Monte Carlo.",
        sections: [
          {
            heading: "Per macchine e quasi-macchine",
            list: [
              "Supporto nella ricerca delle leggi e dei regolamenti applicabili alla macchina",
              "Verifica di corrispondenza tra macchina e requisiti di sicurezza applicabili",
              "Verifica della sicurezza degli equipaggiamenti elettrici (CEI EN 60204-1 e s.m.i.)",
              "Verifica degli equipaggiamenti pneumatici e idraulici",
              "Creazione del fascicolo tecnico e sua archiviazione",
              "Redazione del manuale d'uso e manutenzione",
              "Prove strumentali: rumore, vibrazioni, campi elettromagnetici, compatibilità elettromagnetica",
              "Verifica dei circuiti di comando (PL & SIL)",
              "Marcatura CE",
            ],
            image: ASSETS.risk,
          },
          {
            heading: "Servizi di valutazione",
            list: [
              "Rischio di esposizione a rumore",
              "Rischio di esposizione a vibrazioni",
              "Rischio di esposizione a campi elettromagnetici",
              "Rischio collegato alla movimentazione manuale dei carichi",
              "Rischio collegato all'uso di macchine e impianti",
              "Rischio chimico",
            ],
          },
          {
            heading: "Software per l'affidabilità",
            paragraph:
              "Fornitura di software per le analisi secondo Telcordia, Mil-HDBK-217, 217 Plus, IEC TR 62380, NSWC-98/LE1.",
          },
          {
            heading: "Il nostro libro sul tema",
            paragraph:
              "«La Nuova Direttiva Macchine 2006/42/CE» — la guida Aldebran alla direttiva, disponibile su Amazon.",
            link: { label: "Vedi il libro su Amazon", href: "https://www.amazon.it/dp/B0CVRLHQSY" },
          },
        ],
      },
      regulation: {
        overline: "Normativa · Scadenza 20.01.2027",
        title: "Regolamento Macchine (UE) 2023/1230",
        lead: "Cosa cambia e come prepararsi entro gennaio 2027. Il Regolamento sostituisce la Direttiva 2006/42/CE e introduce aggiornamenti significativi per i produttori di macchinari industriali.",
        sections: [
          {
            heading: "Perché agire ora",
            paragraph:
              "Sebbene già in vigore, l'applicazione obbligatoria decorre dal 20 gennaio 2027. Una preparazione anticipata è essenziale per evitare ritardi, ridurre i rischi e garantire l'accesso continuo al mercato UE.",
          },
          {
            heading: "01 · Risposte rapide",
            paragraph:
              "Hai domande sul nuovo Regolamento? Il nostro team risponde con indicazioni concrete e mirate sulla tua casistica.",
          },
          {
            heading: "02 · Aldebran School",
            paragraph:
              "Formazione pratica e strutturata per comprendere e applicare correttamente le nuove regole nella tua realtà aziendale.",
          },
          {
            heading: "Il tuo partner per la conformità",
            paragraph:
              "Competenza globale, supporto normativo su misura e accesso più rapido al mercato UE. I nostri esperti sono pronti ad accompagnarti in ogni fase.",
          },
        ],
        cta: { label: "Contatta un esperto", to: "/contatti" },
      },
      industry: {
        overline: "Servizi · Digital Transformation",
        title: "Industria 4.0 / 5.0",
        lead: "Trasformiamo la tua impresa in una fabbrica connessa e intelligente, pronta a cogliere le opportunità della transizione 5.0. Dalla sensoristica alla simulazione digitale: un percorso completo e modulare.",
        sections: [
          {
            heading: "Sensoristica, IoT e automazione",
            paragraph:
              "Installiamo sensori intelligenti e sistemi IoT su macchinari nuovi o esistenti per monitorare stato e prestazioni delle macchine in tempo reale, consumi energetici, vibrazioni, anomalie e parametri di sicurezza e qualità. I dati alimentano dashboard intuitive collegate a sistemi gestionali o MES.",
            list: ["Riduzione dei fermi", "Manutenzione predittiva", "Tracciabilità totale"],
          },
          {
            heading: "Digitalizzazione delle linee",
            paragraph:
              "Digitalizziamo ogni fase del ciclo produttivo: mappatura e automazione delle operazioni manuali, collegamento tra macchine ed ERP, tracciabilità di lotti, operatori e materiali.",
            list: ["Flussi ottimizzati", "Riduzione degli errori", "Gestione dati centralizzata"],
            image: ASSETS.factory,
          },
          {
            heading: "Simulazione 3D e Digital Twin",
            paragraph:
              "Creiamo modelli digitali avanzati della linea produttiva per simulare il funzionamento in tempo reale, testare nuovi layout o investimenti e analizzare i colli di bottiglia. Il Digital Twin è la copia virtuale dell'impianto, aggiornata costantemente dai sensori: prevede i guasti, ottimizza i cicli e forma il personale in ambienti simulati.",
            list: ["Miglioramento continuo", "Controllo remoto", "Preparazione all'Industria 5.0"],
          },
        ],
      },
      ai: {
        overline: "Servizi · Artificial Intelligence",
        title: "Intelligenza Artificiale per l'Industria",
        lead: "Soluzioni AI per aumentare produttività, qualità e competitività. Ti aiutiamo a introdurre l'AI in azienda con soluzioni concrete e su misura, pensate per chi produce, utilizza o gestisce macchinari industriali e impianti complessi.",
        sections: [
          {
            heading: "Analisi predittive e manutenzione intelligente",
            paragraph:
              "Applichiamo algoritmi di machine learning ai dati di macchine e impianti per prevedere i guasti prima che si verifichino, ottimizzare la pianificazione della manutenzione e ridurre costi operativi e fermi macchina.",
          },
          {
            heading: "Ottimizzazione dei processi",
            paragraph:
              "Modelli AI che analizzano i flussi produttivi per ottimizzare i parametri di lavorazione in tempo reale, ridurre gli scarti, migliorare la qualità finale e supportare decisioni strategiche con dati oggettivi.",
          },
          {
            heading: "Interfacce intelligenti e assistenti virtuali",
            paragraph:
              "Interfacce AI vocali o testuali che integrano manualistica interattiva per operatori e manutentori, supporto tecnico in tempo reale tramite chatbot e formazione continua sull'uso di macchinari complessi.",
          },
          {
            heading: "Controllo qualità con visione artificiale",
            paragraph:
              "Sistemi di AI e Computer Vision per ispezioni automatiche sulle linee di produzione, riconoscimento di difetti e conformità di prodotto, tracciabilità visiva con archiviazione di dati e immagini.",
            image: ASSETS.robotics,
          },
        ],
        cta: { label: "Richiedi un'analisi gratuita", to: "/contatti" },
      },
    },
    contact: {
      overline: "Contatti",
      title: "Parliamone.",
      sub: "Raccontateci il vostro progetto: vi risponderemo al più presto con una prima valutazione.",
      emailLabel: "Email",
      phoneLabel: "Telefono",
      formTitle: "Richiedi una consulenza",
      name: "Nome e cognome",
      company: "Azienda",
      email: "Email",
      service: "Servizio di interesse",
      servicePlaceholder: "Seleziona un servizio",
      message: "Messaggio",
      messagePlaceholder: "Descrivi brevemente la tua esigenza…",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti risponderemo al più presto.",
      error: "Qualcosa è andato storto. Riprova o scrivici a info@aldebran.com.",
      note: "Inviando il modulo, la tua richiesta viene recapitata direttamente al nostro team: info@aldebran.com.",
    },
    footer: {
      tagline: "Servizi e prodotti tecnici per l'industria, da oltre 25 anni.",
      servicesTitle: "Servizi",
      companyTitle: "Azienda",
      contactsTitle: "Contatti",
      home: "Home",
      contacts: "Contatti",
      regulation: "Regolamento UE 2023/1230",
      rights: "© 2026 Aldebran — Engineering Group. Tutti i diritti riservati.",
      certifico: "CertificoQR — un prodotto Aldebran",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      risk: "Risk Analysis",
      regulation: "Machinery Regulation",
      industry: "Industry 4.0/5.0",
      ai: "AI",
      contacts: "Contacts",
      cta: "Request Consultation",
      menu: "Menu",
      close: "Close",
    },
    common: {
      discover: "Learn more",
      allServices: "All services",
      backToServices: "Back to services",
      external: "External site",
      emailUs: "Email us",
    },
    home: {
      heroOverline: "Aldebran — Engineering Group · Since 1999",
      heroLines: ["Engineering, compliance", "and technical documentation", "without borders."],
      heroSub:
        "For over 25 years we have supported machine and plant manufacturers: technical documentation, risk analysis, certification and digital transformation — in every market worldwide.",
      heroCtaPrimary: "Explore our services",
      heroCtaSecondary: "EU Regulation 2023/1230",
      stats: [
        { value: "25+", label: "years of experience" },
        { value: "8", label: "areas of specialization" },
        { value: "ISO 13849", label: "IEC 62061 · applied standards" },
        { value: "2027", label: "new Machinery Regulation" },
      ],
      aboutOverline: "Who we are",
      aboutTitle: "A single technical partner, from design to market.",
      aboutText:
        "Aldebran has provided technical services and products to companies for over 25 years. We combine regulatory expertise, engineering culture and digital tools to bring machines and plants to international markets — safely and in full compliance.",
      aboutCta: "Talk to an expert",
      servicesOverline: "What we do",
      servicesTitle: "Eight areas of specialization. One single point of contact.",
      servicesSub:
        "From technical documentation to artificial intelligence: we cover the entire industrial product lifecycle.",
      certifico: {
        badge: "New · An Aldebran product",
        title: "CertificoQR",
        text: "Certification made instant: one QR code per machine. Technical file, manuals and declarations of conformity always accessible, up to date and verifiable by anyone, anywhere.",
        cta: "Visit certificoqr.com",
      },
      regOverline: "Regulatory deadline",
      regTitle: "Machinery Regulation (EU) 2023/1230",
      regText:
        "It replaces Directive 2006/42/EC and introduces significant requirements for manufacturers. Mandatory application starts on 20 January 2027: preparing early means protecting your access to the EU market.",
      regDays: "days to mandatory application",
      regCta: "How we prepare you",
      marquee: [
        "Technical Documentation",
        "Risk Analysis",
        "CE Marking",
        "EU Regulation 2023/1230",
        "3D Documentation",
        "Project Management",
        "Industry 4.0/5.0",
        "Artificial Intelligence",
        "CertificoQR",
      ],
      ctaTitle: "Let's talk about your next project.",
      ctaText:
        "Tell us about your machine, your plant, your target market. We will reply with a concrete proposal.",
      ctaButton: "Request a consultation",
    },
    services: [
      {
        slug: "manualistica",
        title: "Technical Documentation",
        short:
          "Clear, compliant and multilingual user and maintenance manuals: an integral part of your product.",
        image: ASSETS.blueprintSketch,
        path: "/servizi/manualistica",
      },
      {
        slug: "documentazione-3d",
        title: "3D Documentation",
        short:
          "Interactive technical content from your CAD models: exploded views, step-by-step procedures, navigable 3D PDFs.",
        image: ASSETS.doc3d,
        path: "/servizi/documentazione-3d",
      },
      {
        slug: "risk-analysis",
        title: "Risk Analysis",
        short:
          "Risk analysis of machines and plants according to EN ISO 13849-1/2, IEC 62061, FTA, PHA, Monte Carlo.",
        image: ASSETS.risk,
        path: "/risk-analysis",
      },
      {
        slug: "regolamento-ue",
        title: "EU Regulation 2023/1230",
        short:
          "Full support in the transition from Directive 2006/42/EC to the new Machinery Regulation.",
        image: ASSETS.blueprint,
        path: "/regolamento-ue",
      },
      {
        slug: "certificazioni-e-sicurezza",
        title: "Certification & Safety",
        short:
          "Certification of machines and plants under the Machinery, ATEX, PED, EMC directives and CE marking.",
        image: ASSETS.sicurezza,
        path: "/servizi/certificazioni-e-sicurezza",
      },
      {
        slug: "project-management",
        title: "Project Management",
        short:
          "Planning, monitoring and control: WBS, Gantt, project risk and documentation management.",
        image: ASSETS.pm,
        path: "/servizi/project-management",
      },
      {
        slug: "industria-4-5",
        title: "Industry 4.0/5.0",
        short:
          "Sensors, IoT and Digital Twin to turn your factory into a connected, intelligent ecosystem.",
        image: ASSETS.factory,
        path: "/industria-4-5",
      },
      {
        slug: "ai",
        title: "AI for Industry",
        short:
          "Predictive maintenance, machine vision and virtual assistants: AI concretely applied to industry.",
        image: ASSETS.robotics,
        path: "/ai",
      },
    ],
    servicesPage: {
      overline: "Our services",
      title: "Engineering expertise, from paper to digital.",
      sub: "Eight areas of specialization covering the entire industrial product lifecycle: documentation, compliance, safety, innovation.",
      certifico: {
        badge: "An Aldebran product",
        title: "CertificoQR — certification one scan away",
        text: "CertificoQR is the Aldebran platform that links every machine to a unique QR code: technical file, user manuals, declarations of conformity and maintenance documents become accessible in seconds, from any device, in any language. No more lost documents, outdated versions or slowed-down audits.",
        points: [
          "Always up-to-date digital technical file",
          "Instant access via QR code on the machine",
          "Multilingual, revision-controlled documents",
          "Full traceability for audits and inspections",
        ],
        cta: "Go to certificoqr.com",
      },
    },
    details: {
      "manualistica": {
        overline: "Services · Technical Documentation",
        title: "User Manuals",
        lead: "The user manual is an integral part of the product: without it, no machine can be sold on the European market. And it must be published in the language of the country where the product is marketed.",
        sections: [
          {
            heading: "The cost of a poor manual",
            list: [
              "Harm to people or property from improper product use",
              "Costly product liability cases",
              "Product recalls",
              "Deterioration of perceived quality",
              "Damage to brand image",
              "Frustrated users who turn to competitors",
            ],
          },
          {
            heading: "The value of an effective manual",
            list: [
              "Minimizes harm to people and property",
              "Reduces product liability risk",
              "Lowers after-sales service costs",
              "Improves overall product quality",
              "Strengthens the brand",
              "Creates satisfied customers",
            ],
          },
          {
            heading: "Why choose Aldebran",
            paragraph:
              "Our user manuals protect the user with clear safety instructions, are legally valid and standards-compliant, easy to understand and free of jargon, designed for quick reading and enriched with clear, meaningful illustrations.",
          },
          {
            heading: "Translation services",
            paragraph:
              "Your texts are translated by highly qualified native-speaker translators. A modern translation management system saves time and money during translation and layout.",
          },
        ],
      },
      "documentazione-3d": {
        overline: "Services · 3D Documentation",
        title: "3D Documentation",
        lead: "3D documentation is the new frontier of technical documentation. Aldebran offers high-performance solutions that revolutionize how information is represented and published across all sectors.",
        sections: [
          {
            heading: "Custom technical content",
            list: [
              "Detailed work instructions",
              "Illustrated parts catalogues",
              "Interactive technical manuals",
              "Custom, navigable 3D PDF documents",
            ],
          },
          {
            heading: "Visual content creation",
            paragraph:
              "We produce clear, intuitive content from CAD models: exploded views, step-by-step procedures, bills of materials (BOM/part lists), technical illustrations and multilingual descriptive texts.",
            image: ASSETS.doc3d,
          },
          {
            heading: "Cloud distribution and collaboration",
            list: [
              "Secure, private distribution of 3D content",
              "Real-time collaboration with international teams",
              "Management of technical documentation updates and revisions",
            ],
          },
          {
            heading: "Interactive and multimedia solutions",
            list: [
              "Visual instructions for assembly and maintenance",
              "Interactive catalogues for e-commerce and remote maintenance",
              "Integration with web platforms and PLM/ERP systems",
            ],
          },
        ],
      },
      "certificazioni-e-sicurezza": {
        overline: "Services · Certification",
        title: "Machine Certification & Safety",
        lead: "Complete assistance in the certification of machines, plants and products, and in workplace safety — with an international outlook.",
        sections: [
          {
            heading: "What we do",
            list: [
              "Certification according to the Machinery, Medical Devices, Low Voltage, Electromagnetic Compatibility, PED and construction products directives",
              "Consulting on workplace safety, risk analysis, noise testing, environmental measurements, sworn expert reports",
              "Assistance in applying local laws and standards in international plant projects",
              "Liaison with foreign institutions and regulatory bodies on construction, safety, environmental protection, certification and product liability",
              "Sale and sourcing of technical documents and standards: technical standards, military norms, codes, international laws and regulations",
              "Project supervision for compliance with ISO, DIN, VDI, AENOR, AFNOR, UNI, BS, GOST, SNIP standards",
            ],
          },
        ],
      },
      "project-management": {
        overline: "Services · Project Management",
        title: "Project Management",
        lead: "We plan, monitor and deliver your projects in compliance with company procedures and agreed objectives.",
        sections: [
          {
            heading: "Service activities",
            list: [
              "Setup and planning of new projects in compliance with procedures defined by the company or the client",
              "Analysis of objectives and specifications, cost and time estimates",
              "Monitoring and management of progress for ongoing projects",
              "Planners for loading project data, analysis and reporting",
              "Creation and management of the project WBS, network and Gantt chart",
              "Definition of procedures",
              "Management of project criticalities and risks",
              "Project documentation management",
              "Assistance and facilitation of project meetings with all involved parties",
              "Delivery of documentation to the client",
            ],
          },
        ],
      },
    },
    pages: {
      risk: {
        overline: "Services · Safety",
        title: "Risk Analysis",
        lead: "Risk analysis of machines and plants in accordance with the applicable directives — Machinery, PED, ATEX — using EN ISO 13849-1/2, IEC 62061, McKinney, FTA, PHA and Monte Carlo methodologies.",
        sections: [
          {
            heading: "For machines and partly completed machinery",
            list: [
              "Support in researching the laws and regulations applicable to your machinery",
              "Verification of correspondence between the machine and applicable safety requirements",
              "Safety checks on electrical equipment (CEI EN 60204-1 and later versions)",
              "Checks on pneumatic and hydraulic equipment",
              "Creation of the technical file and its archiving",
              "Drafting of the use and maintenance manual",
              "Instrumental tests: noise, vibrations, electromagnetic fields, electromagnetic compatibility",
              "Verification of control circuits (PL & SIL)",
              "CE marking",
            ],
            image: ASSETS.risk,
          },
          {
            heading: "Evaluation services",
            list: [
              "Noise exposure risk",
              "Vibration exposure risk",
              "Electromagnetic field exposure risk",
              "Risk associated with manual handling of loads",
              "Risk related to the use of machines and plants",
              "Chemical risk",
            ],
          },
          {
            heading: "Reliability software",
            paragraph:
              "Supply of software for analyses according to Telcordia, Mil-HDBK-217, 217 Plus, IEC TR 62380, NSWC-98/LE1.",
          },
          {
            heading: "Our book on the subject",
            paragraph:
              "«La Nuova Direttiva Macchine 2006/42/CE» — Aldebran's guide to the directive, available on Amazon (in Italian).",
            link: { label: "See the book on Amazon", href: "https://www.amazon.it/dp/B0CVRLHQSY" },
          },
        ],
      },
      regulation: {
        overline: "Regulation · Deadline 20.01.2027",
        title: "Machinery Regulation (EU) 2023/1230",
        lead: "What changes and how to prepare by January 2027. The Regulation replaces Directive 2006/42/EC and introduces significant updates for industrial machinery manufacturers.",
        sections: [
          {
            heading: "Why act now",
            paragraph:
              "Although already in force, mandatory application starts on 20 January 2027. Early preparation is essential to avoid delays, reduce risks and ensure continued access to the EU market.",
          },
          {
            heading: "01 · Quick answers",
            paragraph:
              "Questions about the new Regulation? Our team replies with concrete, targeted guidance for your specific case.",
          },
          {
            heading: "02 · Aldebran School",
            paragraph:
              "Practical, structured training to understand and correctly apply the new rules within your company.",
          },
          {
            heading: "Your compliance partner",
            paragraph:
              "Global expertise, tailored regulatory support and faster access to the EU market. Our experts are ready to guide you through every phase.",
          },
        ],
        cta: { label: "Contact an expert", to: "/contatti" },
      },
      industry: {
        overline: "Services · Digital Transformation",
        title: "Industry 4.0 / 5.0",
        lead: "We turn your company into a connected, intelligent factory, ready to seize the opportunities of the 5.0 transition. From sensors to digital simulation: a complete, modular path.",
        sections: [
          {
            heading: "Sensors, IoT and automation",
            paragraph:
              "We install smart sensors and IoT systems on new or existing machinery to monitor machine status and performance in real time, energy consumption, vibrations, anomalies, and safety and quality parameters. Data feeds intuitive dashboards connected to management or MES systems.",
            list: ["Reduced downtime", "Predictive maintenance", "Full traceability"],
          },
          {
            heading: "Production line digitalization",
            paragraph:
              "We digitalize every phase of the production cycle: mapping and automation of manual operations, machine-to-ERP connectivity, traceability of batches, operators and materials.",
            list: ["Optimized flows", "Error reduction", "Centralized data management"],
            image: ASSETS.factory,
          },
          {
            heading: "3D simulation and Digital Twin",
            paragraph:
              "We create advanced digital models of your production line to simulate operation in real time, test new layouts or investments and analyse bottlenecks. The Digital Twin is the virtual copy of your plant, constantly updated by sensors: it predicts failures, optimizes cycles and trains staff in simulated environments.",
            list: ["Continuous improvement", "Remote control", "Readiness for Industry 5.0"],
          },
        ],
      },
      ai: {
        overline: "Services · Artificial Intelligence",
        title: "Artificial Intelligence for Industry",
        lead: "AI solutions to increase productivity, quality and competitiveness. We help you introduce AI into your company with concrete, tailored solutions designed for those who produce, use or manage industrial machinery and complex plants.",
        sections: [
          {
            heading: "Predictive analytics and smart maintenance",
            paragraph:
              "We apply machine learning algorithms to machine and plant data to predict failures before they occur, optimize maintenance planning and reduce operating costs and downtime.",
          },
          {
            heading: "Process optimization",
            paragraph:
              "AI models that analyse production flows to optimize processing parameters in real time, reduce waste, improve final quality and support strategic decisions with objective data.",
          },
          {
            heading: "Intelligent interfaces and virtual assistants",
            paragraph:
              "Voice or text AI interfaces integrating interactive manuals for operators and maintenance staff, real-time technical support via chatbot and continuous training on complex machinery.",
          },
          {
            heading: "Quality control with machine vision",
            paragraph:
              "AI and Computer Vision systems for automatic inspections on production lines, defect and product conformity recognition, visual traceability with data and image archiving.",
            image: ASSETS.robotics,
          },
        ],
        cta: { label: "Request a free analysis", to: "/contatti" },
      },
    },
    contact: {
      overline: "Contacts",
      title: "Let's talk.",
      sub: "Tell us about your project: we will get back to you shortly with an initial assessment.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      formTitle: "Request a consultation",
      name: "Full name",
      company: "Company",
      email: "Email",
      service: "Service of interest",
      servicePlaceholder: "Select a service",
      message: "Message",
      messagePlaceholder: "Briefly describe your needs…",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent. We will get back to you shortly.",
      error: "Something went wrong. Please retry or write to info@aldebran.com.",
      note: "By submitting the form, your request is delivered directly to our team: info@aldebran.com.",
    },
    footer: {
      tagline: "Technical services and products for industry, for over 25 years.",
      servicesTitle: "Services",
      companyTitle: "Company",
      contactsTitle: "Contacts",
      home: "Home",
      contacts: "Contacts",
      regulation: "EU Regulation 2023/1230",
      rights: "© 2026 Aldebran — Engineering Group. All rights reserved.",
      certifico: "CertificoQR — an Aldebran product",
    },
  },
};
